module.exports = __webpack_public_path__ + "static/media/logo.73ce9c12.png";